//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import { checkBreakpoint, getAllImmobiliPageData, getSeo } from '~/helpers';

const COL_COUNT = 3;

export default {
    name: 'ImmobiliPage',

    async asyncData(context) {
        const postData = await getAllImmobiliPageData(context, COL_COUNT);

        return {
            postData,
        };
    },

    data: () => ({
        checkBreakpoint: {
            downXl: false,
            upXl: false,
        },
        seo: {
            title: null,
            description: null,
            breadcrumb_title: null,
            is_robots_noindex: null,
            is_robots_nofollow: false,
            is_robots_noarchive: null,
            is_robots_noimageindex: null,
            is_robots_nosnippet: null,
            twitter_title: null,
            twitter_image: null,
            twitter_description: null,
            twitter_image_id: null,
            twitter_image_source: null,
            open_graph_title: null,
            open_graph_description: null,
            open_graph_image: null,
            open_graph_image_id: null,
            open_graph_image_source: null,
            open_graph_image_meta: null,
        },
    }),

    async fetch() {
        const thisHasPostData = Object.prototype.hasOwnProperty.call(
            'postData',
            this
        );

        if (thisHasPostData && typeof this.postData !== 'undefined') {
            const postDataHasSeo = Object.prototype.hasOwnProperty.call(
                'seo',
                this.postData
            );

            if (postDataHasSeo && typeof this.postData.seo !== 'undefined') {
                this.seo = await this.postData.seo;
            }
        }
    },

    head() {
        if (this.seo === null || typeof this.seo === 'undefined') {
            return;
        }

        const fullPath = this.$route.fullPath;

        const baseURL = this.$config.BASE_URL || 'https://www.libertyhomes.it/';

        const currentURL = `${baseURL}${String(fullPath).replace(/^\//, '')}`;

        const headToReturn = getSeo(this.seo, currentURL, true);

        return { ...headToReturn };
    },

    computed: {
        ...mapState({
            colCount: ({ immobili }) => immobili.colCount,
            scroll: ({ scroll }) => scroll.scroll,
            immobili: ({ immobili }) => immobili.immobili,
            immobiliFiltered: ({ immobili }) => immobili.immobiliFiltered,
            immobiliSplitted: ({ immobili }) => immobili.immobiliSplitted,
            isLocomotiveActive: ({ scroll }) => scroll.isLocomotiveActive,
            limit: ({ scroll }) => scroll.limit,
            mapboxKey: ({ map }) => map.mapboxKey,
        }),

        ...mapGetters([
            'immobili/GET_COL_COUNT',
            'scroll/GET_SCROLL',
            'immobili/GET_IMMOBILI',
            'immobili/GET_IMMOBILI_COUNT',
            'immobili/GET_IMMOBILI_FILTERED',
            'immobili/GET_IMMOBILI_SPLITTED',
            'scroll/GET_IS_LOCOMOTIVE_ACTIVE',
            'scroll/GET_LIMIT',
            'map/GET_MAPBOX_KEY',
        ]),
    },

    mounted() {
        this.checkBreakpoint.downXl = checkBreakpoint.down('xl');
        this.checkBreakpoint.upXl = checkBreakpoint.up('xl');

        if (checkBreakpoint.down('xl')) {
            setTimeout(() => {
                document.querySelector('.o-header__wrapper').style.transform =
                    'translateY(0px)';

                window.scrollTo({
                    top: window.innerHeight * 0.5 - (16 * 3 + 45 / 2),
                    left: 0,
                    behavior: 'smooth',
                });
            }, 1000);

            if (this.isLocomotiveActive === false) {
                window.addEventListener('scroll', (e) => {
                    let way = 'up';

                    if (
                        document.documentElement.scrollTop >
                        this.scroll.current.y
                    ) {
                        way = 'down';
                    }

                    if (document.documentElement.scrollTop === 0) {
                        way = 'up';
                    }

                    if (
                        document.documentElement.scrollTop >=
                        Math.round(
                            document
                                .querySelector('body')
                                .getBoundingClientRect().height
                        )
                    ) {
                        way = 'down';
                    }

                    this.$store.dispatch('scroll/UPDATE_SCROLL', {
                        previous: {
                            ...this.scroll.current,
                        },
                        current: {
                            y: document.documentElement.scrollTop,
                            x: document.documentElement.scrollLeft,
                            way,
                        },
                    });

                    this.$store.dispatch('scroll/UPDATE_LIMIT', {
                        previous: {
                            ...this.limit.current,
                        },
                        current: {
                            top: 0,
                            bottom: Math.round(
                                document
                                    .querySelector('body')
                                    .getBoundingClientRect().height
                            ),
                            left: 0,
                            right: Math.round(
                                document
                                    .querySelector('body')
                                    .getBoundingClientRect().right
                            ),
                        },
                    });

                    if (way === 'up') {
                        if (document.querySelector('.o-header__wrapper')) {
                            document.querySelector(
                                '.o-header__wrapper'
                            ).style.transform = 'translateY(0px)';
                        }

                        if (
                            document.querySelector('.o-footer--desktop') &&
                            checkBreakpoint.up('xl')
                        ) {
                            document.querySelector(
                                '.o-footer--desktop'
                            ).style.transform = 'translateY(0px)';
                        }
                    } else {
                        if (document.querySelector('.o-header__wrapper')) {
                            document.querySelector(
                                '.o-header__wrapper'
                            ).style.transform = 'translateY(-100%)';
                        }

                        if (
                            document.querySelector('.o-footer--desktop') &&
                            checkBreakpoint.up('xl')
                        ) {
                            document.querySelector(
                                '.o-footer--desktop'
                            ).style.transform = 'translateY(100%)';
                        }
                    }
                });

                window.scrollTo({
                    top: window.innerHeight * 0.5 - (16 * 3 + 45 / 2),
                    left: 0,
                    behavior: 'smooth',
                });
            }
        }
    },

    destroyed() {
        this.$store.dispatch('immobili/RESET_IMMOBILI_FILTERED');
    },

    methods: {
        ...mapActions([
            'immobili/UPDATE_COL_COUNT',
            'immobili/UPDATE_IMMOBILI_FILTERED',
            'immobili/UPDATE_IMMOBILI',
            'scroll/UPDATE_SCROLL',
            'scroll/UPDATE_LIMIT',
            'ui/UPDATE_IS_PAGE_IMMOBILI',
        ]),

        handleContentHeight(e) {
            if (checkBreakpoint.down('xl')) {
                window.scrollTo({
                    top: window.innerHeight - (16 * 3 + 45 / 2),
                    left: 0,
                    behavior: 'smooth',
                });
            }
        },

        handleCardMouseEnter(idx) {
            const marker = document.querySelector(`[data-item="${idx}"]`);

            if (marker) {
                marker.classList.add('is-active');
            }
        },

        handleCardMouseExit(idx) {
            const marker = document.querySelector(`[data-item="${idx}"]`);

            if (marker) {
                const popup = document.querySelector(
                    `[data-popup-item="${idx}"]`
                );

                if (popup === null || typeof popup === 'undefined') {
                    marker.classList.remove('is-active');
                }
            }
        },

        async updateImmobili(filters) {
            const immobili = [...this.immobili];

            const filtersList = {
                ville: filters.tipologia.ville,
                appartamenti: filters.tipologia.appartamenti,
                case: filters.tipologia.case,
                ospiti: parseInt(filters.ospiti, 10),
                parcheggio: filters.servizi.parcheggio,
                piscina: filters.servizi.piscina,
                giardino: filters.servizi.giardino,
                spiaggia: filters.servizi.spiaggia,
                animali: filters.servizi.animali,
            };

            // Check if filters has almost one value set as true
            let hasTrue = false;
            let ospitiIsZero = false;

            Object.entries(filtersList).forEach(([key, vals]) => {
                if (key !== 'ospiti' && vals === true) {
                    hasTrue = true;
                }

                if (key === 'ospiti' && vals === 0) {
                    ospitiIsZero = true;
                }
            });

            // If filters are all off, return all immobili
            if (hasTrue === false && ospitiIsZero === true) {
                await this.$store.dispatch(
                    'immobili/UPDATE_IMMOBILI_FILTERED',
                    immobili
                );
                return null;
            }

            const listImmobiliData = [];
            // console.groupCollapsed();
            immobili.forEach((item, idx) => {
                const immobile = item.card;

                listImmobiliData[idx] = {
                    ville: immobile.servizi.tipologia === 'villa',
                    appartamenti: immobile.servizi.tipologia === 'appartamento',
                    case: immobile.servizi.tipologia === 'casa',
                    ospiti: parseInt(immobile.servizi.ospitiFilters, 10),
                    parcheggio: immobile.servizi.parcheggio,
                    piscina: immobile.servizi.piscina,
                    giardino: immobile.servizi.giardino,
                    spiaggia: immobile.servizi.spiaggiaPrivata,
                    animali: immobile.servizi.animali,
                };

                // console.log(`${immobile.pretitle} ${immobile.title}`, immobile.servizi.piscina);
            });
            // console.groupEnd();

            const immobiliFiltered = immobili.filter((item, idx) => {
                let isOk = true;
                const immobile = item.card;

                Object.entries(filtersList).forEach(([key, value]) => {
                    if (key === 'ville' || key === 'appartamenti' || key === 'case') {
                        if (
                            (
                                filtersList.ville === false &&
                                filtersList.appartamenti === false &&
                                filtersList.case === false
                            ) ||
                            (
                                filtersList.ville === true &&
                                filtersList.appartamenti === true &&
                                filtersList.case === true
                            )
                        ) {
                            return;
                        }
                    }

                    // If key and value of filters is "0", the element is ok
                    if (key === 'ospiti' && value === 0) {
                        return;
                    }

                    // If key and value of filters is "false", the element is ok
                    if (value === false) {
                        return;
                    }

                    // If build value for "ospiti" is more or equal to filter value, isOk = true
                    if (
                        key === 'ospiti' &&
                        listImmobiliData[idx][key] >= value
                    ) {
                        return;
                    }

                    // Filter active, check if element is ok
                    if (listImmobiliData[idx][key] !== value) {
                        isOk = false;
                    }
                });

                if (isOk === true) {
                    return true;
                }

                return false;
            });

            await this.$store.dispatch('immobili/UPDATE_IMMOBILI_FILTERED', [
                ...immobiliFiltered,
            ]);
        },
    },
};
